import { Popover } from "@mui/material";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 50px;
  gap: 2px;
`;

const UserName = styled.div`
  width: 100%;
  font-size: 13px;
  text-align: center;
  overflow: hidden;
  height: 30px;
  text-overflow: ellipsis;
`;

const MoreInfoPopover = styled(Popover)`
  .MuiPopover-paper {
    display: flex;
    flex-direction: column;
    width: 260px;
    padding: 10px;
    gap: 16px;
    border-radius: 10px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EditUser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EditUserButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.navBarIcons};

  &.no-permission {
    cursor: not-allowed !important;
    pointer-events: auto !important;

    background-color: transparent;
    color: rgba(0, 0, 0, 0.26);
  }
`;

export {
  Container,
  UserName,
  MoreInfoPopover,
  UserInfo,
  EditUser,
  EditUserButton
};
